import { DateTime } from 'luxon';
import { DateHelper } from '../../../../helpers/date.helper';

function DateHeader({ date, uniqueJourneyDates }: { date: DateTime; uniqueJourneyDates: DateTime[] }) {
  return (
    <div className={`py-2 px-3 bg-white border-bottom border-blue ${uniqueJourneyDates.length === 1 && DateHelper.isSameDay(date, DateTime.now()) ? 'visually-hidden' : ''}`}>
      {DateHelper.formatWithWeekday(date)}
    </div>
  );
}

export default DateHeader;
